import request from '@/utils/request'
const api_name = 'storeinformation'
export default{
    getAllStoreInformation(){
        return request({
            url:`/${api_name}/getallstoreinformations`,
            method:'get'
        })
    },
    getStoreInformationBystoreinformation(pojo){
        return request({
            url:`/${api_name}/getstoreinformationbystoreinformationsubject`,
            method:'post',
            data:pojo
        })
    },
    addstoreinformation(pojo){
        return request({
            url:`/${api_name}/addstoreinformationbyweb`,
            method:'post',
            data:pojo
        })
    },
    updatestoreinformation(pojo){
        return request({
            url:`/${api_name}/updatestoreinformation`,
            method:'post',
            data:pojo
        })
    },
    deletestoreinformation(id){
        return request({
            url:`/${api_name}/deletestoreinformation?id=`+id,
            method:'delete',
        })
    },
    
}







